// AUTO-GENERATED — character slugs that have an animated card video in Supabase
// storage (eros-media/character-videos/<slug>.mp4). Regenerate with
// scripts/reference-characters after uploading new clips.

const STORAGE_BASE =
  'https://bjhhccyzlmjpgurefeef.supabase.co/storage/v1/object/public/eros-media/character-videos';

export const ANIMATED_SLUGS = new Set<string>([
  // Clips were uploaded but never listed (found 2026-10-23).
  'signe-rasmussen',
  'Sofia-volkov',
  'lilia-sorokina',
  'zuri-malone',
  'aisling-o-rourke',
  // Character factory v6 top-ups, 2026-10-20/21
  'inaya-bouaziz',
  'zofia-ruzicka',
  'ember-caldwell',
  'daria-sokolova',
  'aislinn-doherty',
  'yueling-zhang',
  'yeonwoo-cho',
  'calliope-stavros',
  'amina-bouzid',
  'zorahine-brackett',
  'larissa-cardoso',
  'nayara-cedeno',
  'rhea-langston',
  'ximena-calderon',
  'lidia-kovalenko',
  'vespera-khatri',
  'liraz-bayat',
  'nour-al-sayed',
  'lotte-bergmann',
  'yasmina-fadel',
  'renata-almeida',
  'eira-lindholm',
  'nia-thompson',
  'laine-vetra',
  'sariya-nguyen',
  'fiorella-santini',
  'luciana-rivas',
  'ama-serwaa',
  'damaris-encarnacion',
  'kavya-desai',
  'yeseul-moon',
  'mabel-sutton',
  'milena-horakova',
  'xochitl-ramos',
  // Character factory 2026-10-20 batch: clips uploaded, characters public
  'aarohi-deshmukh',
  'claire-leclerc',
  'ebba-nystrom',
  'esmeralda-rios',
  'eun-ji-kwon',
  'farah-alami',
  'giulia-ferrari',
  'harper-ellison',
  'lila-martin',
  'liora-valdes',
  'meher-kaur',
  'nadia-el-masri',
  'niamh-o-shea',
  'rania-saleh',
  'ruolan-feng',
  'somsri-thani',
  'soojin-rhee',
  'xochitl-rendon',
  'zadie-harrington',
  'zoraya-pimentel',
  'zoya-karpova',
  // Character factory 2026-10-14..20: anime/furry top-ups and v6 (synced from the publish logs)
  'maja-lindberg',
  'freja-m-ller',
  'liv-s-rensen',
  'kari-vik',
  'signe-pedersen',
  'ragna-lund',
  'vigdis-haugen',
  'priya-kapoor',
  'yuna-takahashi',
  'ebba-nilsson',
  'ines-carvalho',
  'liora-katz',
  'aino-virtanen',
  'niamh-o-connor',
  'tamsin-rowe',
  'saffron-vega',
  'liora-klein',
  'nadia-petrov',
  'yasemin-kaya',
  'edda-sorensen',
  'hanne-kruger',
  'runa-halvorsen',
  'ebba-nyberg',
  'ylva-nordstrom',
  'mirabel-langley',
  'phoebe-thornton',
  'jasper-wynn',
  'miles-adler',
  'callum-frost',
  'nolan-briggs',
  'dorian-valek',
  'nariya-srisawat',
  'lucia-ferri',
  'zofia-nowak',
  'amina-el-fassi',
  'elowen-harlan',
  'shalini-menon',
  'linnea-vinter',
  'yuna-hoshino',
  'maeve-callaghan',
  'nisa-thongchai',
  'eira-lindqvist',
  'efia-boateng',
  'nayeli-baez',
  'anushka-mehra',
  'nayara-quintero',
  'amal-kettani',
  'zofia-novakova',
  'hinata-soma',
  'lien-zhao',
  'bitna-hwang',
  'laleh-khadem',
  'mirela-farias',
  'lila-hargrove',
  'soraya-benali',
  'bronagh-reilly',
  'lucia-ramirez',
  'mizuki-hayashi',
  'leyla-karaca',
  'suyin-liu',
  'damaris-lopez',
  'rafaela-ortiz',
  'liora-kallas',
  'lea-dumont',
  'sasithorn-vang',
  'zoraiah-brooks',
  'sofia-rinaldi',
  'livia-bastos',
  'ji-yeon-kang',
  'ijeoma-nwankwo',
  'jagoda-mazur',
  'leila-farouk',
  'laila-benchekroun',
  'mei-ling-hsu',
  'esha-virani',
  'luz-estrada',
  'nadia-fernandez',
  'maren-calloway',
  'valeria-rojas',
  'layla-nassar',
  'adaeze-nwosu',
  'serafina-conti',
  'soraya-el-khalil',
  'samaira-iyer',
  'haeun-seo',
  'maja-zielinska',
  'sirin-phothong',
  'amelie-rousseau',
  'talita-ribeiro',
  'zoraida-quintana',
  'blythe-kincaid',
  'itzel-solis',
  'vittoria-esposito',
  'zainab-okeke',
  'lotte-vermeer',
  'bree-callahan',
  'daria-kuznetsova',
  'eilidh-macleod',
  'livia-rocha',
  'nayla-fakhoury',
  'malika-benziane',
  'chalita-phan',
  'rana-farsi',
  'mira-ivanov',
  'xochitl-mendez',
  'ximena-lozano',
  'satsuki-morimoto',
  'thalia-vasilakis',
  'lilia-strakova',
  'nia-harper',
  'liora-vance',
  'solana-bautista',
  // Character factory v5, 2026-10-17: 40 women, erotic card loops
  'chalida-rattanakorn',
  'haruka-nishimori',
  'zofia-kowalczyk',
  'lina-haddad',
  'rowan-mcallister',
  'camila-duarte',
  'anika-rao',
  'amara-eze',
  'liesel-brandt',
  'jiwoo-baek',
  'solana-quintero',
  'sorcha-gallagher',
  'lianhua-zhou',
  'anya-petrova',
  'valeria-rossi',
  'jade-washington',
  'ingrid-lind',
  'luna-delgado',
  'ximena-vargas',
  'nadia-el-fassi',
  'chanya-vongsa',
  'hinata-kuroda',
  'liora-ellison',
  'raquel-mendes',
  'priya-malhotra',
  'amina-okoro',
  'zeynep-yilmaz',
  'lieselotte-weber',
  'lidia-baranowska',
  'so-jin-kwak',
  'giada-moretti',
  'zoraiah-blake',
  'marisol-rivera',
  'niamh-brennan',
  'astrid-holm',
  'layla-mansour',
  'inara-novikova',
  'isadora-navarro',
  'solene-paredes',
  'yuhan-wen',
  // Character factory: anime + furry, all genders (2026-10-13)
  'eleni-papadakis',
  'helene-march',
  'rhiannon-sage',
  'lian-chen',
  'norah-ellison',
  'linnea-holm',
  'celine-duarte',
  'blythe-mercer',
  'samira-khan',
  'anouk-delacroix',
  'callum-reeves',
  'henrik-solberg',
  'lucas-ferreira',
  'yuto-kimura',
  'stefan-kovac',
  'declan-foley',
  'rafe-holloway',
  'thorne-beckett',
  'rami-haddad',
  'kento-fujimoto',
  'carmen-delgado',
  'tabitha-hayes',
  'winona-clarke',
  'zinnia-monroe',
  'corinne-whitfield',
  'jocelyn-hayesworth',
  'penelope-wells',
  'damaris-kato',
  'raquel-flores',
  'thea-kensington',
  'eira-holst',
  'sofie-berglund',
  'brielle-hollis',
  'felix-romero',
  'dimitri-volkov',
  'ivor-north',
  'leland-crowe',
  'hugo-brandt',
  'anneliese-rivers',
  'birgitta-hawthorne',
  'cressida-montgomery',
  'eulalia-blackwood',
  'fiorenza-sterling',
  'gwendolen-ashford',
  'heloise-kingsley',
  'imelda-winchester',
  'jocasta-pembroke',
  'kresley-fairchild',
  // Character factory: men + trans (2026-10-13)
  'lina-costa',
  'kelsey-oliveira',
  'zelda-alvarez',
  'hazel-navarro',
  'lenore-hartley',
  'mabel-langford',
  'rosalie-vance',
  'simone-keller',
  'lavinia-fletcher',
  'octavia-whitman',
  'petra-sullivan',
  'marina-kline',
  'evelyn-cross',
  'lydia-shaw',
  'faye-whitaker',
  'juno-sinclair',
  // Character factory batches, 2026-10-13: 20 men, first 4 trans women (factory/publish.ts)
  'liam-carter',
  'hiro-tanaka',
  'finn-olsen',
  'erik-hansen',
  'jamal-wright',
  'omar-khalil',
  'theo-berg',
  'darius-cole',
  'malik-johnson',
  'nils-bergstrom',
  'yusuf-alami',
  'luca-moretti',
  'emre-yilmaz',
  'noah-eriksson',
  'connor-walsh',
  'tyler-stone',
  'logan-pierce',
  'ryan-mitchell',
  'nathan-ford',
  'brandon-grant',
  'delphine-laurent',
  'elif-demir',
  'elowen-price',
  'opal-moreno',
  // Character factory batches, 2026-10-12 (scripts/reference-characters/factory/publish.ts)
  'lila-hart',
  'nadia-petrova',
  'mila-jensen',
  'priya-sharma',
  'nora-lind',
  'clara-dubois',
  'liora-voss',
  'soren-hale',
  'thalia-cruz',
  'kaia-lennox',
  'reya-solis',
  'mira-kwan',
  'yuna-sato',
  'signe-dahl',
  'ines-silva',
  'saskia-lane',
  'isadora-vale',
  'cora-bennett',
  'maeve-rossi',
  'rhea-patel',
  'selene-dray',
  'nadine-quill',
  'celeste-rook',
  'rowan-ellis',
  'coral-finch',
  'greer-lang',
  'thora-quillan',
  'indigo-raine',
  'vespera-sol',
  'indira-moss',
  'beatriz-mendes',
  'renee-calder',
  'daphne-rivera',
  'tamsin-reed',
  'luz-herrera',
  'iris-holt',
  'nisha-rao',
  'tala-reyes',
  'marta-bianchi',
  'tara-mendoza',
  'minji-park',
  'aisha-okoro',
  'maya-torres',
  'lise-madsen',
  'claudia-moreau',
  'frederikke-larsen',
  'rafaela-santos',
  'nattaya-boon',
  'thandiwe-ndlovu',
  'zainab-okafor',
  'fiona-o-brien',
  'oksana-koval',
  'eliska-novak',
  'isabel-morales',
  'fernanda-lopes',
  'ximena-ruiz',
  'esperanza-vargas',
  'yara-aquino',
  'rania-sayegh',
  'serafina-lombardi',
  '-5c5ej7',
  'Sofia-volkov',
  'abimbola-ifunanya',
  'aiko-shimizu',
  'akari-tanaka',
  'amani-nkosi',
  'amara-nandi',
  'amina-osei',
  'amira-osei',
  'amora-d1kkbo',
  'anaya-sharma',
  'anika-joshi',
  'anjali-devi',
  'anmed-ravena',
  'anna-nowak',
  'anya-al-khatib',
  'aoife-murphy',
  'astrid-bergstr-m',
  'astrid-bergstr-m-1',
  'astrid-bjornstad-1',
  'aya-bousso',
  'ayana-okoro',
  'bianca-moretti',
  'briar-thorne',
  'brunhilde-ackermann',
  'brunhilde-bruiser-schmidt',
  'camilla-santos',
  'camille-laurent',
  'catalina-herrera',
  'catalina-herrera-1',
  'cleo-hassan',
  'deepika-iyer',
  'eirwen-forseti',
  'elara-moreau-1',
  'elara-morozova',
  'elara-vasilievna',
  'elara-vestby',
  'eleanor-ainsworth',
  'eleanor-fitzgerald',
  'elena-kowalski',
  'elena-mendoza',
  'elena-popescu',
  'elin-solbj-rg',
  'elsa-andersson',
  'emma-de-jong',
  'emma-johnson',
  'esmeralda-esme-cruz',
  'eszter-kovacs',
  'freja-larsson',
  'freja-lundstr-m',
  'freja-petersen',
  'freya-hartmann',
  'freya-volkov',
  'genevieve-dubois',
  'giulia-rossi',
  'greta-edelmann',
  'greta-hoffmann',
  'greta-m-ller',
  'han-mei-li',
  'helena-petrova',
  'himari-amamiya',
  'ifiok-nkanga',
  'ines-santos',
  'inge-sveinsdottir',
  'ingrid-s-rensen',
  'isabela-castillo',
  'isabela-de-souza',
  'isabela-flores',
  'isabella-moretti',
  'isabella-rodriguez',
  'isabella-vasquez',
  'isobel-von-dorn',
  'isolde-von-richter',
  'jana-qo5xkr',
  'jasleen-kaur-shergill',
  'jia-yue',
  'kaiyo-tanaka',
  'kanya-the-phoenix-arayakorn',
  'kasumi-nakamura',
  'lana-al-masri',
  'lea-martin',
  'lin-zheng',
  'louisa-edelweiss',
  'maria-papadopoulou',
  'marisol-esperanza',
  'mathlida-winchester',
  'meenakshi-sundaram',
  'meera-chakravarti',
  'mei-tanaka',
  'mei-tanaka-1',
  'nadya-chen',
  'nala-adu-darko',
  'nala-moremi',
  'naserian-mollel',
  'neferet-ra-neferu',
  'odette-moreau',
  'olivia-smith',
  'princess-aeisha-meher-chand',
  'rani-devi',
  'ren-kumo',
  'riya-patel',
  'rosa-delgado',
  'rosario-rosie-vargas',
  'sable-moreau',
  'sade-adebayo',
  'sakura-nakamura',
  'sigrid-larsen',
  'sofia-ivanova',
  'sofia-laurent',
  'sofia-mendoza',
  'sofia-morales',
  'solveig-haardrad',
  'solveig-nygaard',
  'solveig-strom',
  'sophie-dubois',
  'temiloluwa-temi-adeyemi',
  'tigist-alemayehu',
  'tove-christensen',
  'valentina-espinoza',
  'valentina-la-bruja-morales',
  'valentina-rivera',
  'valentina-vale-cruz',
  'vivienne-deschamps',
  'x-chitl-guzm-n',
  'yasmin-al-mansoori',
  'yasmin-hassan',
  'yasmin-karimi',
  'yukiko-tanaka',
  'yumi-nakamura',
  'zahra-khaled',
  'zahra-nour',
  'zahra-nour-1',
  'zara-volkov',
  // 2026-07 batch (Drive upload)
  'aurora-thatcher',
  'bianca-costa',
  'freya-lindqvist',
  'margot-laurent',
  'mei-lin',
  'mia-rossi',
  'nova-taylor',
  'selena-marino',
  'shirley-wong',
  'valeria-popescu',
]);

// Bump when the stored clips are re-encoded — busts the year-long CDN/browser
// cache so viewers fetch the new file instead of the stale one.
// v3 = native 720p/30fps H.264 CRF26 from the local masters (sharp, ~1MB).
const CLIP_VERSION = '3';

/** Public URL of a character's looping card video, or null if none exists. */
export function characterVideoUrl(slug: string): string | null {
  return ANIMATED_SLUGS.has(slug)
    ? `${STORAGE_BASE}/${slug}.mp4?v=${CLIP_VERSION}`
    : null;
}
